import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import PurchaseTickets from './purchase-tickets';

export default function LivewireLive2019(props) {
  const agenda = {
    '1:00pm': ['Welcome and Overview'],
    '1:10pm': ['The Great Debate: Should you be risk on or risk off?'],
    '2:00pm': ['Fireside Chat with Scott Nuttall, Co-President and Co-Chief Operating Officer, KKR'],
    '2:20pm': ['Panel: The Good, the Bad and the Ugly'],
    '3:00pm': ['Networking and Refreshments'],
    '3:30pm': ['Welcome message from Bell Direct'],
    '3:40pm': ['How tomorrow’s generation lives and what it means for your portfolio'],
    '4:00pm': ['Panel: Ten years from now this is how the investing world has changed'],
    '4:40pm': ['Shocking predictions for 2020 and beyond'],
    '5:00pm': ['Live music, drinks and canapes by Chiswick'],
  };

  const VCenter = styled.div`
    text-align: center;
    max-width: 100%;
    height: auto;
  `;

  const ButtonContainer = styled.div`
    text-align: center;
    max-width: 100%;
    height: auto;
    margin-top: 30px;
    margin-bottom: 30px;
  `;

  const Agenda = styled.table`
    width: 100%;
    max-width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;
    border-collapse: collapse;
  `;

  const THead = styled.thead`
    display: table-header-group;
    vertical-align: middle;
    border-color: inherit;
  `;

  const TH = styled.th`
    border-bottom: 2px solid #e9ecef;
    padding: .25rem;
    vertical-align: top;
    border: 1px solid #e9ecef;
    text-align: left;
  `;

  const TD = styled.td`
    padding: .25rem;
    vertical-align: top;
    border: 1px solid #e9ecef;
  `;

  const Image = styled.img`
    max-width: 100%;
    height: auto;
    padding-bottom: 30px;
  `;

  const SmallImage = styled(Image)`
    max-width: 25%;
    height: auto;
    padding-bottom: 30px;
  `;

  const VideoContainer = styled.div`
    position: relative;
    padding-bottom: 349px;
    padding-top: 30px;
    overflow: hidden;
  `;

  const IFrame = styled.iframe`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  `;

  const CellLine = styled.div`
    padding: 7px;
  `;

  return (
    <article className="livewire-event">
      <VCenter>
        <h2>
          Magellan’s Hamish Douglass and Platinum’s Andrew Clifford headline an exceptional
          speaker lineup at Livewire Live 2019.
        </h2>
        <p>
          <strong>Join us at Livewire Live 2019</strong>
          <br />
          By Investors, For Investors.
          <br />
          #LWL19
        </p>
        <h4><strong>PROUDLY SPONSORED BY</strong></h4>
        <SmallImage alt="Sponsored by" src={window.getLivewireAssetPath('livewire-events/livewire-live-2019/bell-direct-logo.png')} />
      </VCenter>

      <p>
        Livewire Live 2019 is an investor event like no other. We’ve assembled the top tier
        wealth managers and fund managers to debate the most challenging issues facing investors
        in an innovative and engaging format.
      </p>
      <p>
        <strong>
          Tuesday, 10th September 2019
          <br />
          The Domain Theatre, Art Gallery of NSW
          <br />
          1:00pm - 5:00pm
        </strong>
        <br />
        Followed by live music, drinks and canapés at Chiswick at the Gallery: 5:00pm to 7:00pm
        <br />
        <strong>Cost: $155 plus booking fee</strong>
      </p>
      <hr />

      <h2>Why come to LWL19?</h2>
      <p>
        <strong>Front Row Seats</strong>
        <br />
        Magellan’s Hamish Douglass and Platinum’s Andrew Clifford will reveal the 10 global
        companies that will dominate the next decade.
      </p>
      <p>
        <strong>Exclusive Access</strong>
        <br />
        Australia’s best hedge funds will open up on
        <em>‘The Good, The Bad and The Ugly’</em>
        {' '}
        of stocks listed on the ASX.
      </p>
      <p>
        <strong>Debate</strong>
        <br />
        Watch a live debate as two teams go head-to-head and make their case for why you should be
        <em>‘Risk On, or Risk Off’</em>
        {' '}
        in the current environment.
      </p>
      <p>
        <strong>Beat the Crowd</strong>
        <br />
        The emerging markets of Asia are full of opportunity; we’ve got a local guide to help you
        beat the crowd.
      </p>
      <p>
        <strong>Shocking Predictions</strong>
        <br />
        Be challenged and entertained with these shocking predictions about the events that will
        shape markets in 2020 and beyond.
      </p>

      <h2>Agenda</h2>
      <Agenda>
        <THead>
          <tr>
            <TH>Time</TH>
            <TH>Details</TH>
          </tr>
        </THead>
        <tbody>
          {_.map(agenda, (value, key) => (
            <tr key={key}>
              <TD>
                <CellLine>{key}</CellLine>
              </TD>
              <TD>
                {value.map((line, index) => (
                  <CellLine key={line.substring(0, 10)}>
                    {index ? line : <b>{line}</b>}
                  </CellLine>
                ))}
              </TD>
            </tr>
          ))}
        </tbody>
      </Agenda>

      <h2>
        With access to the experts, you will gain the knowledge to be more confident and
        successful with your future investments.
      </h2>
      <p>
        This is an unmissable event and one afternoon only. Tickets are limited and sell out.
        <strong>Be sure to secure your spot today!</strong>
        {' '}
        We look forward to seeing you there.
        {' '}
      </p>

      <ButtonContainer>
        <PurchaseTickets eventbriteId={props.eventbriteId} buttonText="Secure your spot now" />
      </ButtonContainer>

      <Image src={window.getLivewireAssetPath('livewire-events/livewire-live-2019/speaker-companies.png')} />

      <VideoContainer>
        <IFrame width="560" height="349" src="https://www.youtube.com/embed/W4HQeVoToIA" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
      </VideoContainer>
      <h2>FAQs</h2>

      <p><strong>Directions to the Domain Theatre, Art Gallery of NSW.</strong></p>
      <p>From the front entrance, ground level</p>
      <ol>
        <li>Head towards the rear of the Gallery</li>
        <li>Take the escalators down three levels</li>
        <li>Turn left</li>
        <li>The Domain Theatre is straight ahead</li>
      </ol>

      <p><strong>Accessible directions</strong></p>
      <p>From the rear entrance, lower level 1</p>
      <ol>
        <li>Take the lift (on your left) down two levels, to 3</li>
        <li>Head through the double glass doors</li>
        <li>The Domain Theatre is across the foyer on your right</li>
      </ol>

      <p>
        <strong>How can I contact the organiser with any questions?</strong>
        <br />
        Should you have any questions regarding Livewire Live 2019 please contact us at
        {' '}
        <a href="mailto:team@livewiremarkets.com">team@livewiremarkets.com</a>
      </p>

      <Image alt="Sponsored by" src={window.getLivewireAssetPath('livewire-events/livewire-live-2019/sponsored-by.png')} />

    </article>
  );
}

LivewireLive2019.propTypes = {
  eventbriteId: PropTypes.string.isRequired,
};
